import { Component, Input, OnChanges, ChangeDetectionStrategy } from "@angular/core";

import { BaseComponent, UserService } from "@mypxplat/xplat/core";
import { NgxSpinnerService } from "ngx-spinner";

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: "myp-inline-loader",
  templateUrl: "inline-loader.component.html",
  standalone: false,
})
export class InlineLoaderComponent extends BaseComponent implements OnChanges {
  @Input() loading: boolean = false;
  @Input() height: any;
  @Input() spinnerName: string;
  @Input() spinnerMessage: string | false;
  @Input() color: string = "white";
  /**
   * Cover the whole viewport rather than sitting inline. Use for operations the user must not
   * navigate away from mid-flight; the default backdrop is transparent, so pair it with
   * `bdColor` to actually dim and block the page behind.
   */
  @Input() fullScreen: boolean = false;
  @Input() bdColor: string = "rgba(51,51,51,0.0)";
  constructor(
    userService: UserService,
    private _spinner: NgxSpinnerService
  ) {
    super(userService);
  }

  ngOnChanges(args) {
    if (args.loading && args.loading.currentValue == true) {
      this._spinner.show(this.spinnerName);
    } else if (args.loading && args.loading.currentValue == false) {
      this._spinner.hide(this.spinnerName);
    }

    let body = document.getElementsByTagName("body")[0];
    if (body.classList.contains("theme_plainlight")) {
      this.color = "#00529c";
    }
  }
}
